export default __webpack_public_path__ + "static/panicked-6509936273c7781b7891cb53fedc561a.svg";